import _ from "lodash";
import { matches } from "./wizardFieldMatch.json";

const checkMatch = (wizard, parsedScene) => {
	// loops each rule type for the wizard (commands, devices, etc)
	return _.every(matches[wizard], (ruleType, key) =>
		// loops through the "or" rules
		ruleType.some(andRule =>
			// matches every "and" rules
			andRule.every(matchRule(parsedScene[key]))
		)
	);
};

const matchRule = nodes => nodeRule =>
	// Loops each node in search of a full match for the rule
	_.some(nodes, node =>
		_.every(nodeRule, (value, path) =>
			_.get(node, path) === value
		)
	);

export default checkMatch;
